import { render, staticRenderFns } from "./ChangeLogFilters.vue?vue&type=template&id=08fa8287&"
import script from "./ChangeLogFilters.vue?vue&type=script&lang=js&"
export * from "./ChangeLogFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08fa8287')) {
      api.createRecord('08fa8287', component.options)
    } else {
      api.reload('08fa8287', component.options)
    }
    module.hot.accept("./ChangeLogFilters.vue?vue&type=template&id=08fa8287&", function () {
      api.rerender('08fa8287', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/system/filters/ChangeLogFilters.vue"
export default component.exports